import React, { useEffect, useRef, useState } from "react";
import CustomInputFile from "../CustomInputFile";
import { ImFilePicture } from "react-icons/im";
import { IoLocation } from "react-icons/io5";
import { FaWhatsapp } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import './index.css'
import CustomButton from "../CustomButton";
import axios from "axios";
import CustomInput from "../CustomInput";
import { useDispatch } from "react-redux";
import PhoneInput from "../PhoneInput";
import { Country, State, City }  from 'country-state-city';
import CustomSelector from "../CustomSelector";
import { FaMapLocationDot } from "react-icons/fa6";



const   FormPost = ({typePost, handleUpdateStore, text})=>{
    const dispatch = useDispatch()
    const [visoriaInfo, setVisoriaInfo] = useState({
        img:'',
        description:'',
        linkMensaje:'',
        linkUbicacion:'',
        type: typePost,
        phoneCode:'52',
        country:{name:'Mexico', code:'MX'},
        state:{name:'Guanajuato', code:'GUA'},
        city:''
    })
    const [enableInputs, setEnableInputs] = useState({
        whats: false,
        location:false,
        locationInfo: false
    })
    const [hasMissingData, setHasMissingData] = useState({
        enable: true,
        message:''
    })

    const handleUpdateVisoriaInfo = (e,key)=>{
        setVisoriaInfo(prev => ({...prev, [key]: e.target.value}))
    }
    const getImgFile = (e,key)=>{
        setVisoriaInfo(prev => ({...prev, [key]: e.target.files?.[0]}))

    }

    const handleAddVisoria = async ()=>{
       
            if(!visoriaInfo.description && !visoriaInfo.linkMensaje) return setHasMissingData(prev => ({...prev, enable: false, message:'Agrega los detalles de la visoria  y tú numero'}))
            if(!visoriaInfo.description) return setHasMissingData(prev => ({...prev, enable: false, message:'Escribe los detalles de la visoria'}))
            if(!visoriaInfo.linkMensaje) return setHasMissingData(prev => ({...prev, enable: false, message: 'Agrega tu número para que se comuniquen contigo'}))
            
        const appendData = new FormData();
        appendData.append('picturePost', visoriaInfo.img)
        appendData.append('description', visoriaInfo.description)
        appendData.append('linkMensaje', `${visoriaInfo.phoneCode}${visoriaInfo.linkMensaje.replace(/-/g,'')}`)
        appendData.append('linkUbicacion',visoriaInfo.linkUbicacion)
        appendData.append('type', visoriaInfo.type)
        if(enableInputs.locationInfo){
            appendData.append('pais', visoriaInfo.country.name)
            appendData.append('estado', visoriaInfo.state.name)
        }
        const config = {headers:{
            'content-type':'multipart/form-data',
        }}
        const url = 'https://web-production-58ed.up.railway.app/api/create/Post'
        const result = await axios.post(url, appendData, config)
        handleUpdateStore(result?.data)

    }
    const renderUbication = ()=>{
        if(typePost === 'visorias') return<></>
        if(enableInputs.location) return <CustomInput keyInput={'linkUbicacion'} 
        handleUpdateVisoriaInfo={handleUpdateVisoriaInfo} placeHolder={'Ingresa el link del lugar'}
         type={'text'} Icon={<IoMdClose onClick={()=>{ 

            setEnableInputs(prev => ({...prev, ['location']: false}))}}
          style={{width:'30px', height:'30px',cursor:'pointer'}}  />}  />

        return (
                <CustomButton  handleEnableInput={()=> setEnableInputs(prev => ({...prev, ['location']: true}))} 
                title={'Agregar link ubicacion'} Icon={<IoLocation style={{width:'30px', height:'30px', color:'grey'}} />} /> 
        )
    }
    const renderWhats = ()=>{
        if(enableInputs.whats) return <PhoneInput keyInput='linkMensaje' handleUpdateVisoriaInfo={handleUpdateVisoriaInfo} 
        Icon={<IoMdClose onClick={()=> {
            setEnableInputs(prev => ({...prev, ['whats']: false}))
            setVisoriaInfo(prev =>({...prev, linkMensaje:''}) )

        }}
         style={{width:'30px', height:'30px',cursor:'pointer'}}  />}  />

        return ( <CustomButton handleEnableInput={()=> setEnableInputs(prev => ({...prev, ['whats']: true}))}  
        title={'Agregar whats'} Icon={<FaWhatsapp style={{width:'30px', height:'30px',color:'grey'}} />} />
        )
    }
    const renderSelectorCountry = ()=>{
        if(enableInputs.locationInfo) return (<div className="form-post-selector-country-state">
            <CustomSelector list={Country?.getAllCountries()} keyTarget={'country'} 
            setVisoriaInfo={setVisoriaInfo} visoriaInfo={visoriaInfo}
             />
             <CustomSelector list={State.getStatesOfCountry(visoriaInfo?.country?.code)} keyTarget={'state'} 
            setVisoriaInfo={setVisoriaInfo} visoriaInfo={visoriaInfo}
             />
    </div>)
            return ( <CustomButton handleEnableInput={()=> setEnableInputs(prev => ({...prev, ['locationInfo']: true}))}  
            title={'Agregar pais y estado'} Icon={<FaMapLocationDot  style={{width:'30px', height:'30px',color:'grey'}} />} />
            )
    }
    return(
        <div className="form-post-container" >
        <div>
            <textarea
            onChange={e => handleUpdateVisoriaInfo(e, 'description')}
            placeholder={text}
            style={{width:'100%', height:'100px', fontFamily:'sans-serif', fontSize:'17px'}}
            
            />
        </div>

        {
            visoriaInfo.img && (
                <img width={150} height={180} src={URL.createObjectURL(visoriaInfo.img)} />
            )
        }
        <CustomInputFile getImgFile={getImgFile} Icon={<ImFilePicture style={{width:'30px', height:'30px', color:'grey'}} />} title={'Agregar foto'} />
        {renderSelectorCountry()}
        {renderUbication()}
        {renderWhats()}
        {!hasMissingData.enable && hasMissingData.message && (!visoriaInfo.linkMensaje || !visoriaInfo.description) && <p style={{color:'firebrick', fontSize:'12px'}}>{hasMissingData.message }</p>}
        <div className="form-post-container-button-section">
            <button onClick={handleAddVisoria}>Crear publicación</button>
        </div>
    </div>
    )
}

export default FormPost